import { render, staticRenderFns } from "./PendingReports.vue?vue&type=template&id=792448bf"
import script from "./PendingReports.vue?vue&type=script&lang=js"
export * from "./PendingReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports